import { DialogContent } from '../../entities/dialog-content.entity';
import { ProgramList } from '../../constants/program-list';
import {
  AlbertaSupportsContactCentre,
  HelpInfoEdmonton,
  HelpInfoOfficeHours,
  HelpInfoPhoneDefault,
} from '../common/contact-info';
import { CalloutVariant } from '../../entities/callout-content.entity';
const diaName = ProgramList.dia;
const aishName = ProgramList.aish;
const adapName = ProgramList.adap;
// import { VerifyAccountUrl } from '../../constants/urls';

export const AishDialog_SignerPage_ChangesInProgress = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Your spouse/partner is making changes to the application`,
  bodyText: `When your spouse/partner has completed the changes, we will let you know so you can review them.`,
} as DialogContent;

export const AishDialog_SignerPage_ChangesCompleteOnReturn = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Please review again`,
  confirmButtonText: 'Ok',
  bodyText: `<p>Something in the application might have changed since your last visit. Please review again.</p><p>If you're not sure what has changed, ask your spouse/partner so that you can review the updated information.</p>`,
} as DialogContent;

export const AishDialog_SignerPage_ChangesCompleteOnView = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Please review again`,
  confirmButtonText: 'Ok',
  bodyText: `<p>Your spouse/partner has finished making changes to the application. Your screen has refreshed automatically to display the most up-to-date information.</p><p>If you're not sure what has changed, ask your spouse/partner so that you can review the updated information.</p>`,
} as DialogContent;

export const AishDialog_SignerPage_DeclineVerification = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Decline CRA Consent`,
  confirmButtonText: 'Decline for now',
  cancelButtonText: 'Back',
  bodyText: `<p>If you choose not to provide your CRA Consent at this time, your spouse/partner will not be able to submit their ${diaName.abbreviation} application.</p><p>Please speak with your spouse/partner if you have concerns about providing your CRA Consent.</p><p>If you change your mind later, your spouse/partner can resend the invite or download and print the form for you to sign.</p>`,
} as DialogContent;

export const AishDialog_SignerPage_ConfirmVerification = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Provide CRA Consent`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'Cancel',
  bodyText: `Are you sure you want to provide your CRA Consent?`,
} as DialogContent;

export const AishDialog_SignaturePage_DeactivateSignatureRequest = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Cancel signature request`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `<p>If you continue, the person you invited will no longer be able to access this application to give their CRA Consent. The information you have provided about them will still be submitted as part of the application.</p><p><b>Do you want to continue?</b></p>`,
} as DialogContent;

export const AishDialog_SignaturePage_RemoveUploadedForms = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Uploaded document will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `<p>If you continue, the Consent and Declaration that you have uploaded will be removed.</p>
    <p><b>Do you want to continue?</b></p>`,
} as DialogContent;

export const AishDialog_Application_UpdateSnapshot = {
  calloutVariant: CalloutVariant.Information,
  headerText: `Updates sent`,
  okButtonText: 'Ok',
  bodyText: `
  If you made changes to your spouse/partner’s information, those changes were shared with them automatically.
  They already have access through the invite you sent before, so you do not need to send another invite.
  Your spouse/partner must provide their CRA Consent before you can submit the application.`,
} as DialogContent;

export const AishDialog_MySituation_MaritalStatusChange = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Your spouse/partner's access will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `<p>If you continue:</p>
    <ul>
      <li>Your spouse/partner's information will be removed from the application.</li>
      <li>Your spouse/partner will no longer be able to access this application to give their Consent and Declaration.</li>
    </ul>
    <p><strong>Do you want to continue?</strong></p>`,
} as DialogContent;

export const AishDialog_MySituation_TrusteeChange = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Your spouse/partner's access will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `<p>If you continue:</p>
    <ul>
      <li>Your spouse/partner will no longer be able to provide their CRA Consent digitally.</li>
      <li>You will need to download and print the Consent and Declaration form.</li>
      <li>You, your Trustee/Guardian/person with Power of Attorney and your spouse/partner will need to sign the form in ink.</li>
    </ul>
    <p><strong>Do you want to continue?</strong></p>`,
} as DialogContent;

export const AishDialog_SpousePartner_SpouseLivesWith = {
  calloutVariant: CalloutVariant.Important,
  headerText: `Your spouse/partner's access will be removed`,
  confirmButtonText: 'Yes',
  cancelButtonText: 'No',
  bodyText: `If you change your answer to this question, your spouse/partner's Consent and Declaration will no longer be required and the invite will be revoked. 
  <p>Do you want to change your answer?</p>`,
} as DialogContent;

export const AishDialog_Dashboard_VerifyAccount = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'Verify your Alberta.ca Account',
  confirmButtonText: 'Start verification',
  cancelButtonText: 'Not now',
  bodyText: `
  <ul class="noTopMargin">
    <li>Apply faster - Depending on your situation, you won't need to download, print, sign, and upload some or all forms.</li>
    <li>Protect your identity - Helps make sure no one else can use your account.</li>
  </ul>
  `,
} as DialogContent;

export function Get_AishDialog_OboPage_DraftApplicationExists(
  applicantName: string,
  hasSubmittedApplication: boolean
): DialogContent {
  return {
    calloutVariant: 'important',
    headerText: 'Application already exists',
    confirmButtonText: 'Continue',
    cancelButtonText: 'Cancel',
    bodyText: `You have already started ${
      hasSubmittedApplication ? 'a new application' : 'an application'
    } for ${applicantName}. Would you like to continue the application?`,
  } as DialogContent;
}

export function Get_AishDialog_OboPage_SubmittedApplicationExists(applicantName: string): DialogContent {
  return {
    calloutVariant: 'important',
    headerText: 'Application already exists',
    confirmButtonText: 'View',
    cancelButtonText: 'Cancel',
    bodyText: `You have already submitted an application for ${applicantName}. Would you like to view the application?`,
  } as DialogContent;
}

export function Get_AishDialog_DashboardPage_New_Application(
  hasApplicationSubmittedBeforeAdap: boolean,
  dateStr: string
): DialogContent {
  return {
    calloutVariant: CalloutVariant.Important,
    headerText: ``,
    confirmButtonText: 'Start a new application',
    cancelButtonText: 'Back',
    bodyText: `
   
    ${
      hasApplicationSubmittedBeforeAdap
        ? `If you submitted an application for ${aishName.abbreviation} prior to ${dateStr}, and are still awaiting an outcome, do not complete the ${diaName.fullName} (${diaName.abbreviation}) application. Once your existing application is assessed, if eligible, your file will be placed into the program that best suits your unique needs and abilities. If you are eligible for ${adapName.abbreviation} and wish to be assessed for ${aishName.abbreviation}, you can apply using the ${diaName.fullName} application at that time.`
        : `If you previously submitted the ${diaName.fullName} application and are still awaiting an outcome, do not re-apply. `
    }
          <p>For more information, please contact:</p>
  <strong>${AlbertaSupportsContactCentre}</strong><br />
  Toll-free: <a [href]="'tel:' + infoPhoneDefault">${HelpInfoPhoneDefault}</a
  ><br />
  Toll-free (Edmonton): <a [href]="'tel:' + infoEdmonton">${HelpInfoEdmonton}</a> <br /><br />
  <strong>Office hours:</strong><br />
  ${HelpInfoOfficeHours}
</div>
    `,
  } as DialogContent;
}

export const AishDialog_Dashboard_StartApplication = {
  calloutVariant: CalloutVariant.Information,
  headerText: 'New application',
  confirmButtonText: 'Start a new application',
  cancelButtonText: 'Cancel',
  bodyText: `Unsubmitted application(s) will be deleted after 12 months of inactivity.`,
} as DialogContent;

export const AishDialog_Review_ConfirmSubmission = {
  calloutVariant: CalloutVariant.Important,
  headerText: 'Confirm submission',
  confirmButtonText: 'Yes, submit application',
  cancelButtonText: 'Cancel',
  bodyText: `Are you sure you want to submit this application?`,
} as DialogContent;
